import { createContext, useContext } from "react";

export const ColorModeContext = createContext<"light" | "dark">("light");

export function useColorMode() {
  return useContext(ColorModeContext);
}
